import { QuestionCircleOutlined } from '@ant-design/icons'
import { Form, InputNumber, Popover, Typography } from 'antd'
import { NamePath } from 'antd/es/form/interface'
import { FC, useCallback } from 'react'
import CalculationPosition from '../../../../../../../types/api/calculation-position'
import { StrategyPopoverContent } from '../../../../calculation-form/components/other/quantity-per-roll/components/strategy-popover-content'

interface QuantityPerRollProps {
    name: NamePath
}

interface Position {
    copies?: number
}

const QuantityPerRoll: FC<QuantityPerRollProps> = ({ name }) => {
    const form = Form.useFormInstance()
    const calculationPosition = Form.useWatch(['list', name, 'calculationPosition'], form) as
        | CalculationPosition
        | undefined
    const positions = Form.useWatch(['list', name, 'positions'], form) as Position[] | undefined
    const quantityPerRoll = Form.useWatch(['list', name, 'quantityPerRoll'], form) as number | undefined
    const totalCopies = (positions || []).reduce((sum, position) => sum + (position?.copies || 0), 0)

    const viewStrategyQuantityPerRoll = useCallback(() => {
        if (!quantityPerRoll || !calculationPosition) return 'Намотка по'

        return (
            <Popover
                title={
                    <Typography.Title style={{ marginTop: 8 }} level={5}>
                        Стратегии решения
                    </Typography.Title>
                }
                content={
                    <StrategyPopoverContent
                        cp={calculationPosition}
                        labelName={'Этикетка'}
                        copies={totalCopies}
                        cols={calculationPosition.withoutCutting ? calculationPosition.virtualStamp?.floods : calculationPosition.stampFloods || calculationPosition.stamp?.floods || 0}
                        quantityPerRoll={quantityPerRoll || 0}
                    />
                }
            >
                <span
                    style={{
                        cursor: 'help',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 6,
                        borderBottom: '1px dashed rgba(0, 0, 0, 0.35)',
                        paddingBottom: 1,
                    }}
                >
                    Намотка по
                    <QuestionCircleOutlined style={{ fontSize: 14, opacity: 0.65 }} aria-hidden />
                </span>
            </Popover>
        )
    }, [calculationPosition, totalCopies, quantityPerRoll])

    return (
        <Form.Item name={[name, 'quantityPerRoll']} label={viewStrategyQuantityPerRoll()}>
            <InputNumber style={{ width: '100%' }} />
        </Form.Item>
    )
}

export default QuantityPerRoll
